var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementValidation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345_5632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00017 1.33337C6.68162 1.33337 5.39269 1.72437 4.29636 2.45691C3.20004 3.18945 2.34555 4.23064 1.84097 5.44882C1.33638 6.66699 1.20436 8.00744 1.4616 9.30064C1.71883 10.5938 2.35377 11.7817 3.28612 12.7141C4.21847 13.6464 5.40636 14.2814 6.69956 14.5386C7.99277 14.7958 9.33322 14.6638 10.5514 14.1592C11.7696 13.6547 12.8108 12.8002 13.5433 11.7038C14.2758 10.6075 14.6668 9.31858 14.6668 8.00004C14.6668 7.12456 14.4944 6.25766 14.1594 5.44882C13.8243 4.63998 13.3333 3.90505 12.7142 3.286C12.0952 2.66694 11.3602 2.17588 10.5514 1.84084C9.74255 1.50581 8.87565 1.33337 8.00017 1.33337ZM8.00017 13.3334C6.94533 13.3334 5.91419 13.0206 5.03712 12.4345C4.16006 11.8485 3.47648 11.0156 3.07281 10.041C2.66914 9.06648 2.56352 7.99412 2.76931 6.95956C2.9751 5.92499 3.48305 4.97468 4.22893 4.2288C4.97481 3.48292 5.92512 2.97497 6.95968 2.76919C7.99425 2.5634 9.06661 2.66902 10.0411 3.07268C11.0157 3.47635 11.8486 4.15994 12.4347 5.037C13.0207 5.91406 13.3335 6.94521 13.3335 8.00004C13.3335 9.41453 12.7716 10.7711 11.7714 11.7713C10.7712 12.7715 9.41465 13.3334 8.00017 13.3334Z",
    fill: "#C13515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 11.3333C8.36835 11.3333 8.66683 11.0349 8.66683 10.6667C8.66683 10.2985 8.36835 10 8.00016 10C7.63197 10 7.3335 10.2985 7.3335 10.6667C7.3335 11.0349 7.63197 11.3333 8.00016 11.3333Z",
    fill: "#C13515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 4.66663C7.82335 4.66663 7.65378 4.73686 7.52876 4.86189C7.40373 4.98691 7.3335 5.15648 7.3335 5.33329V8.66663C7.3335 8.84344 7.40373 9.01301 7.52876 9.13803C7.65378 9.26305 7.82335 9.33329 8.00016 9.33329C8.17697 9.33329 8.34654 9.26305 8.47157 9.13803C8.59659 9.01301 8.66683 8.84344 8.66683 8.66663V5.33329C8.66683 5.15648 8.59659 4.98691 8.47157 4.86189C8.34654 4.73686 8.17697 4.66663 8.00016 4.66663Z",
    fill: "#C13515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_5632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementValidation);
export default __webpack_public_path__ + "static/media/icon_settlement_validation.2e41318e39a3d235bf77982c5c306a3a.svg";
export { ForwardRef as ReactComponent };